<ms-help-box boxType="archivedBets" *ngIf="isArchivedBetsHelpBoxVisible" (closeButtonClick)="onArchivedBetsHelpBoxClose()">
    <div class="archived-bets" (click)="openArchivedBetsPopup()">{{ sitecore.betslip.archivedBetsHelpBox.Title }}</div>
</ms-help-box>
